<form [formGroup]="reportForm">
    <div class="row g-3 align-items-center">
        <div class="col-auto">
            <label class="mb-2">{{ 'PLEASE_SELECT_REPORT_PERIOD' | translate }}:</label>
        </div>
        <div class="col-auto">
            <select class="form-select mb-2" [attr.aria-label]="'PLEASE_SELECT_PERIOD' | translate"
                (change)="onReportPeriodChange(t.value)" #t>
                <option selected disabled>{{ 'PLEASE_SELECT_PERIOD' | translate }}</option>
                <option type="button" ngbDropdownItem *ngFor="let p of reportPeriodOptions" [value]="p.key"
                    [selected]="selectedReportPeriod==p.key">
                    {{ p.title }}
                </option>
            </select>
        </div>
        <div class="col-auto">
            <label class="sr-only" for="startDate">{{ 'START' | translate }}</label>
            <input type="date" [readonly]="datesReadonly" formControlName="startDate"
                class="form-control form-date date-custom mb-2"
                [ngClass]="{ 'is-invalid': reportformsubmitted && reportForm.controls.startDate.errors }" />

            <div *ngIf="reportformsubmitted && reportForm.controls.startDate.errors" class="invalid-feedback">
                <div *ngIf="reportForm.controls.startDate.errors.required">{{ 'PLEASE_SELECT_PERIOD' | translate }}</div>
            </div>
        </div>
        <div class="col-auto">
            <label class="mb-2">-</label>
        </div>
        <div class="col-auto">
            <label class="sr-only" for="stopDate">{{ 'END' | translate }}</label>
            <input type="date" [readonly]="datesReadonly" formControlName="stopDate"
                class="form-control form-date date-custom mb-2"
                [ngClass]="{ 'is-invalid': reportformsubmitted && reportForm.controls.stopDate.errors }"
                formControlName="stopDate" />
            <div *ngIf="reportformsubmitted && reportForm.controls.stopDate.errors" class="invalid-feedback">
                <div *ngIf="reportForm.controls.stopDate.errors.required">{{ 'PLEASE_SELECT_PERIOD' | translate }}</div>
            </div>
        </div>
    </div>
</form>
<br/>
<h4>{{ 'RAW_CAMPAIGNS_DATA_NEW_TAB_NOTICE' | translate }}</h4>
<app-special-datatable [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete"
    [iColumns]="columns" [iData$]="campaignsData" [iShowActions]="true" [iShowExternalAction]="true"
    [iShowExport]="false" [iShowSelect]="false" [iShowEditAction]="false"
    [iShowDeleteAction]="false" (oShowExternal)="viewReportOnNewTab($event)">
</app-special-datatable>